import { PAYMENT_DIRECTION_ID } from 'constants/directions';

import { PresetsEditItems } from './PresetsEditItems';

export const PresetsEditPaymentItems: React.FC = () => (
  <PresetsEditItems
    apiKey="payment_items"
    directionId={PAYMENT_DIRECTION_ID}
    itemsField="paymentItems"
    successText="Пресеты пополнения успешно изменены"
    title="Редактирование пресетов пополнения"
  />
);
